var map = {
	"./ac-milan.png": "584b",
	"./ajax.png": "ba57",
	"./arsenal.png": "3b12",
	"./aston-villa.png": "6d6e",
	"./atalanta.png": "742b",
	"./athletic-bilbao.png": "c83a",
	"./atletico-madrid.png": "e58e",
	"./barcelona.png": "c793",
	"./bayer-leverkusen.png": "5163",
	"./bayern-munich.png": "798a",
	"./benfica.png": "105b",
	"./borussia-dortmund.png": "2bbb",
	"./chelsea.png": "9230",
	"./eintracht-frankfurt.png": "9593",
	"./feyenoord.png": "506d",
	"./inter-milan.png": "ef97",
	"./juventus.png": "41aa",
	"./lazio.png": "2108",
	"./lille.png": "c79b",
	"./liverpool.png": "0542",
	"./lyon.png": "a076",
	"./manchester-city.png": "2c1d",
	"./manchester-united.png": "b5af",
	"./marseille.png": "f591",
	"./monaco.png": "20b5",
	"./napoli.png": "48b6",
	"./newcastle.png": "5130",
	"./paris-saint-germain.png": "23a2",
	"./porto.png": "62a9",
	"./psv.png": "6ff8",
	"./rb-leipzig.png": "4859",
	"./real-madrid.png": "031d",
	"./real-sociedad.png": "8d1e",
	"./roma.png": "15ba",
	"./sevilla.png": "2fe8",
	"./sporting-lisbon.png": "744d",
	"./tottenham.png": "0865",
	"./villarreal.png": "bc30"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "01c3";